module.exports = __webpack_public_path__ + "static/media/cnbc.e187a614.png";